<app-dialog [noActions]="true">
  @if (dialogData.hideTitle) {
    <p title>{{dialogData.title}}</p>
  }

  @if (dialogData.secondTitle) {
    <p class="second-title" secondTitle>{{dialogData.secondTitle}}</p>
  }
  <p subtitle class=" description">{{dialogData.text}}</p>
  @for (button of dialogData.buttons; track button.text) {
  <button class="w-full action-button mb-6" appButton [color]="button.color" (click)="onSubmit(button.action)">{{button.text}}</button>
  }
</app-dialog>
